import { defineComponent as _defineComponent } from 'vue'
import Protocol from "@/Protocol/Protocol.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProtocolFrame',
  setup(__props) {


return { __sfc: true,Protocol }
}

})